import {RouteDefinition} from "../../../routes"
import {KeypadListScreen} from "./KeypadListScreen"
import {InputEditScreen} from "./InputEditScreen"
import {InputListScreen} from "./InputListScreen"
import {KeypadEditScreen} from "./KeypadEditScreen"

export const KeypadSettingsRoutes: RouteDefinition[] = [
    {   // List of keypads.
        routerLink: "/settings/keypad/",
        component: KeypadListScreen
    },
    {   // Settings of a spesific keypad.
        routerLink: '/settings/keypad/:device_id/',
        component: InputListScreen
    },
    {   // Inputs of a spesific keypad.
        routerLink: "/settings/keypad/:device_id/input/:input_id/",
        component: InputEditScreen
    },
    {   // Edit screen for keypad.
        routerLink: "/settings/keypad/:device_id/edit/",
        component: KeypadEditScreen
    }
  ]